import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchSlrmTypesThunk = createAsyncThunk(
  "slrmTypes/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/slrm-types"); // ✅ NEW ROUTE
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const slrmTypesSlice = createSlice({
  name: "slrmTypes",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchSlrmTypesThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchSlrmTypesThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.list = a.payload || [];
    });
    b.addCase(fetchSlrmTypesThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });
  },
});

export default slrmTypesSlice.reducer;